import type { ComponentProps, ReactNode } from 'react';
import { AgnesButton, AgnesTooltip } from '@agnes/ui';
import { Download } from 'lucide-react';

type Props = Omit<ComponentProps<typeof AgnesButton>, 'children'> & {
  children?: ReactNode;
  tooltip?: string;
};

/**
 * Botão de exportação padronizado (CON-4897): AgnesButton "Exportar" com ícone
 * de download e tooltip "Exportar relatório" no hover. Centraliza o texto do
 * tooltip em um único lugar para todas as telas. O rótulo do botão segue
 * "Exportar"; o "relatório" aparece só no tooltip.
 */
export function ExportButton({
  tooltip = 'Exportar relatório',
  children = 'Exportar',
  startIcon,
  dataQa = 'btn-exportar',
  'aria-label': ariaLabel = 'Exportar relatório',
  ...rest
}: Props) {
  return (
    <AgnesTooltip content={tooltip}>
      <AgnesButton
        startIcon={startIcon ?? <Download className="h-4 w-4" />}
        dataQa={dataQa}
        aria-label={ariaLabel}
        {...rest}
      >
        {children}
      </AgnesButton>
    </AgnesTooltip>
  );
}
